import React from "react";
import axios from "axios";
import ReactModal from "react-modal";
import SglContext from "../SglContext";
import { useNavigate } from "react-router-dom";
import IntlTelInput from "react-intl-tel-input";
import "./loginform.css";

// IMPORT IMAGES
import indicator_icon from "../images/Indicator.gif";
import tick_icon from "../images/tick_icon.png";

//API END POINTS
// const sgl_webservice_verify_mobile_phone =
//   Sgl.sglApiUrl + "/iphone.php/webservice/VerifyMobilePhone";
// const sgl_webservice_excluded_countries =
//   Sgl.sglApiUrl +
//   "/iphone.php/webservice/GetRegRestrictedCountries";
// const sgl_webservice_verify_otp =
//   Sgl.sglApiUrl + "/iphone.php/webservice/VerifyOTP";
// const sgl_webservice_clear_session_values =
//   Sgl.sglApiUrl + "/iphone.php/webservice/ClearSessionValues";
// const sgl_webservice_verify_mobile =
//   Sgl.sglApiUrl + "/iphone.php/webservice/VerifyMobile";
// const sgl_webservice_skip_verify_mobile =
//   Sgl.sglApiUrl + "/iphone.php/webservice/SkipVerifyMobile";
// const user_info_url = Sgl.nestApiUrl + "/users/getUser";

let css = '.sgl-plugin-page #sgl-content-wrapper {padding-bottom: 20px;max-width: 600px;margin: 0px;}'
css += '.sgl-plugin-page .credit-text {float: none !important;text-align: center;}'
css += '.sgl-plugin-page .copyright-text {text-align: center;}'

var AddModal = ReactModal;

class VerifyMobileForm extends React.Component {

  get sgl_webservice_verify_mobile_phone() {
    return this.context.sglApiUrl + '/iphone.php/webservice/VerifyMobilePhone';
  }

  get sgl_webservice_excluded_countries() {
    return this.context.sglApiUrl + '/iphone.php/webservice/GetRegRestrictedCountries';
  }

  get sgl_webservice_verify_otp() {
    return this.context.sglApiUrl + '/iphone.php/webservice/VerifyOTP';
  }

  get sgl_webservice_clear_session_values() {
    return this.context.sglApiUrl + '/iphone.php/webservice/ClearSessionValues';
  }

  get sgl_webservice_verify_mobile() {
    return this.context.sglApiUrl + '/iphone.php/webservice/VerifyMobile';
  }

  get sgl_webservice_skip_verify_mobile() {
    return this.context.sglApiUrl + '/iphone.php/webservice/SkipVerifyMobile';
  }

  get user_info_url() {
    return this.context.nestApiUrl + '/users/getUser';
  }

  state = {
    loading: true,
    verify_mobile_open_state: false,
    company_name: "",
    go_to_referer: "",
    flid: this.props.flid,
    mobileNumber: {
      isValid: false,
      rawValue: null,
      countryData: null,
      formattedValue: "",
      extension: null,
    },
  };

  constructor(props) {
    super(props);
    // bind function in constructor instead of render
    // this.checkUserSession();
    this.getAllDataForVerifyMobileForm =
      this.getAllDataForVerifyMobileForm.bind(this);
    this.handlePhoneNumberChange = this.handlePhoneNumberChange.bind(this);
    this.handleBlur = this.handleBlur.bind(this);
  }

  componentDidMount() {
    this.checkUserSession();
  }

  checkUserSession() {
    axios.get(this.user_info_url).then((response) => {
      if (response.data.user && response.data.user != null) {
        this.setState({
          userData: response.data.user,
        });
      }
      this.getAllDataForVerifyMobileForm();
    });
  }

  getAllDataForVerifyMobileForm() {
    axios
      .all([
        axios.get(this.sgl_webservice_excluded_countries),
        axios.get(this.sgl_webservice_verify_mobile, {
          params: {
            flid: this.props.flid,
          },
        }),
        axios.get(this.sgl_webservice_clear_session_values, {
          params: {
            customer_id: this.context.company_id,
          },
        }),
      ])
      .then(
        axios.spread((countries_obj, mobile_obj, company_name_obj) => {
          this.setState({
            loading: false,
            company_name: company_name_obj.data,
            // go_to_referer: mobile_obj.data.go_to_referer,
          });

          // if (!mobile_obj.data.status && !this.state.loading) {
          //   let sgl_plugin_error_message = document.getElementById(
          //     "sgl-plugin-error-message"
          //   );
          //   let sgl_plugin_form = document.getElementById("sgl-plugin-form");

          //   sgl_plugin_form.innerHTML = "";
          //   sgl_plugin_form.style.display = "none";
          //   sgl_plugin_error_message.style.display = "block";
          // }
          // else {
          //   let phone_input = document.querySelector("#telephone-input");

          // window.iti = window.intlTelInput(phone_input, {
          //   dropdownContainer: document.body,
          //   formatOnDisplay: true,
          //   nationalMode: true,
          //   placeholderNumberType: "MOBILE",
          //   preferredCountries: ["us", "ca"],
          //   initialCountry: "us",
          //   utilsScript: "https://showgroundslive.com/js/utils.js",
          //   excludeCountries: countries_obj.data,
          // });
          // }
        })
      );
  }

  handleBlur = () => {
    let errorContainer_bottom = document.getElementById(
      "reg_error_summary_bottom"
    );

    if (
      this.state.mobileNumber.formattedValue === "" ||
      this.state.mobileNumber.isValid
    ) {
      errorContainer_bottom.innerHTML = "";
      errorContainer_bottom.style.display = "none";
    } else {
      errorContainer_bottom.innerHTML = "Please enter valid mobile number";
      errorContainer_bottom.style.display = "block";
    }
  };

  reset = () => {
    let phone_input_hidden = document.getElementById("telephone");
    phone_input_hidden.value = "";
  };

  verifyMobile = () => {
    let errorContainer_bottom = document.getElementById(
      "reg_error_summary_bottom"
    );
    let verify_mobile_button = document.getElementById("verifyMobile_btn");
    let please_wait = document.getElementById("verify_mobile-please-wait");

    if (!this.state.mobileNumber.isValid) {
      errorContainer_bottom.innerHTML = "Please enter valid mobile number";
      errorContainer_bottom.style.display = "block";
      verify_mobile_button.style.display = "block";
      please_wait.style.display = "none";
      return 0;
    } else {
      errorContainer_bottom.innerHTML = "";
      errorContainer_bottom.style.display = "none";
      verify_mobile_button.style.display = "none";
      please_wait.style.display = "block";
    }

    axios
      .get(this.sgl_webservice_verify_mobile_phone, {
        params: {
          mobile_phone: this.state.mobileNumber.formattedValue,
          dial_code: this.state.mobileNumber.countryData.dialCode,
          user_id: this.state.userData.sgl_id,
        },
      })
      .then((response) => {
        if (response.data.result) {
          this.setState({ verify_mobile_open_state: true });
        } else {
          errorContainer_bottom.innerHTML = response.data.error;
          errorContainer_bottom.style.display = "block";
          verify_mobile_button.style.display = "block";
          please_wait.style.display = "none";
        }
      });
  };

  verifyOTP = () => {
    let otp_please_wait = document.getElementById("verify_otp-please-wait");
    let otp_verify_btn = document.getElementById("verify_otp_btn");
    let otp_error_summary = document.getElementById("verify_otp_error_summary");
    let verify_mobile_button = document.getElementById("verifyMobile_btn");
    let mobile_verified = document.getElementById("mobile-verified");
    let otp = document.getElementById("otp");
    let phone_input_hidden = document.getElementById("telephone");
    let phone_input = document.getElementById("telephone-input");
    let please_wait = document.getElementById("verify_mobile-please-wait");

    otp_please_wait.style.display = "block";
    otp_verify_btn.style.display = "none";
    otp_error_summary.style.display = "none";

    axios
      .get(this.sgl_webservice_verify_otp, {
        params: {
          otp: otp.value,
        },
      })
      .then((response) => {
        otp_please_wait.style.display = "none";
        if (response.data.result) {
          verify_mobile_button.style.display = "none";
          mobile_verified.style.display = "block";
          please_wait.style.display = "none";
          // phone_input_hidden.readOnly = true;
          // phone_input.readOnly = true;
          this.setState({ verify_mobile_open_state: false });
          const { navigate } = this.props;
          if(this.props.company_id == -1){
            navigate('/edit-account');
          }else{
            navigate("/");
          }
        } else {
          otp_error_summary.innerHTML = response.data.error;
          otp_error_summary.style.display = "block";
          otp_verify_btn.style.display = "block";
        }
      });
  };

  closeVerifyMobile = () => {
    let verify_mobile_button = document.getElementById("verifyMobile_btn");
    let please_wait = document.getElementById("verify_mobile-please-wait");
    this.setState({ verify_mobile_open_state: false });
    please_wait.style.display = "none";
    verify_mobile_button.style.display = "block";
  };

  skipVerifyMobile = () => {
    axios.get(this.sgl_webservice_skip_verify_mobile)
    .then((response) => {
      const { navigate } = this.props;
      if(response.data.referer != ""){
        window.location.href = response.data.referer;
      }else if(this.state.go_to_referer != ""){
        window.location.href = this.state.go_to_referer;
      }else{
        if (
          localStorage.getItem("playing_video_id") &&
          window.referrer != "" &&
          localStorage.getItem("playing_video_url") == window.referrer
        ) {
          navigate(window.referrer);
        } else if (
          window.referrer &&
          window.referrer != "" &&
          window.referrer !=
          "https://" +
          window.location.hostname +
          "/forgot-password?forgot_password=1"
        ) {
          navigate('/' + window.referrer);
          // navigate(window.referrer);
        } else {
          if(this.props.company_id == -1){
            navigate('/edit-account')
          }else{
            navigate('/')
          }
        }
      }
   });
  }

  handlePhoneNumberChange = (
    _isValid,
    _rawValue,
    _countryData,
    _formattedValue,
    _extension
  ) => {
    this.setState({
      mobileNumber: {
        ...this.state.mobileNumber,
        isValid: _isValid,
        rawValue: _rawValue,
        countryData: _countryData,
        formattedValue: _formattedValue,
        extension: _extension,
      },
    });
  };

  render() {
    const loading = this.state.loading;
    const company_name = this.state.company_name;

    if (loading) {
      return null;
    }

    return (
      <div className='sgl-content-wrapper loginformcss verifymobile'>
        <style>{css}</style>
        <div className='sgl-plugin'>
          <div className='verify_mobile_header'>
            <h1>{company_name}</h1>
          </div>

          <div id='sgl-plugin-form'>
            {/* form start */}
            <div className='div-responsive'>
              <div className='verify-mobile-container'>
                <div className='verify-mobile-message'>
                  <h3>VERIFY MOBILE</h3>
                  <p>
                    As part of the ShowGroundsLive.com response to COVID-19 we
                    are now requiring a verified mobile phone number be on file
                    for our users. ShowGroundsLive.com and show management
                    companies will use your phone number to improve
                    communication between the show company and exhibitors and
                    reduce unnecessary contact and congregation of groups of
                    people. We appreciate your cooperation in this effort.
                    <br />
                    <br />
                    Please enter your Mobile Number.
                    <br />
                    Enter your complete number including country code i.e +1
                    (828) 202-8116.
                  </p>
                </div>

                <div className='full'>
                  {/* <input 
                   type='text'
                  placeholder='Mobile Number'
                  type="tel"
                  name='telephone-input'
                  id='telephone-input'
                 onBlur={this.handleBlur}
                  onChange={this.reset}
                  onKeyup={this.reset}
                />  */}
                  <IntlTelInput
                    style={{
                      width: "100%",
                    }}
                    preferredCountries={["us", "ca"]}
                    initialCountry={"us"}
                    allowDropdown={true}
                    onPhoneNumberChange={this.handlePhoneNumberChange}
                    onPhoneNumberBlur={this.handleBlur}
                    placeholder='Mobile Number'
                    id='telephone-input'
                    name='telephone-input'
                  />
                  <input type='hidden' name='telephone' id='telephone' />
                </div>

                <div className='full bottom'>
                  <a
                    href='javascript:void(0);'
                    id='skip_verification'
                    onClick={this.skipVerifyMobile}>
                    Skip
                  </a>
                  <input
                    type='button'
                    id='verifyMobile_btn'
                    className='button'
                    onMouseDown={this.verifyMobile}
                    value='Verify Mobile'
                  />
                  <span id='verify_mobile-please-wait'>
                    <img src={indicator_icon} /> Verifiying...
                  </span>
                  <span id='mobile-verified'>
                    <img src={tick_icon} /> Verified{" "}
                  </span>
                </div>

                <div className='error_container'>
                  <div>
                    <p
                      className='error_summary reg_error_summary'
                      id='reg_error_summary_bottom'></p>
                  </div>
                </div>
              </div>
            </div>
            {/* form end */}

            <div>
              <AddModal
                isOpen={this.state.verify_mobile_open_state}
                onRequestClose={this.closeVerifyMobile}
                className='mymodal'
                overlayClassName='myoverlay'
                ariaHideApp={false}>
                <h2>Verify Mobile</h2>
                <p>Please enter Verification Code</p>
                <p id='verify_otp_error_summary' className='otp_error_summary'>
                  Please enter verification code sent to your phone.
                </p>
                <input
                  type='text'
                  maxlength='5'
                  id='otp'
                  name='otp'
                  className='otp'
                  placeholder='Verification Code'></input>
                <div>
                  <button
                    onClick={this.closeVerifyMobile}
                    className='verify_mobile_buttons left'>
                    Close
                  </button>
                  <button
                    id='verify_otp_btn'
                    onClick={this.verifyOTP}
                    className='verify_mobile_buttons right'>
                    Verify
                  </button>
                  <span
                    id='verify_otp-please-wait'
                    className='verify_otp-please-wait right'>
                    <img src={indicator_icon} /> Processing...
                  </span>
                </div>
              </AddModal>
            </div>
          </div>

          {/* <div id='sgl-plugin-error-message'>
            <p>
              Sorry, but the page you are looking for has not been found. Try
              checking the URL for errors, then hit the refresh button on your
              browser.
            </p>
          </div> */}
        </div>
      </div>
    );
  }
}
VerifyMobileForm.contextType = SglContext;
export default function(props) {
  const navigate = useNavigate();

  return <VerifyMobileForm {...props} navigate={navigate} />;
}

